var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18C36.5 8.05785 28.4422 0 18.5 0C8.55785 0 0.5 8.05785 0.5 18C0.5 26.986 7.08125 34.432 15.6875 35.7821V23.2031H11.1172V18H15.6875V14.0344C15.6875 9.5238 18.3735 7.03125 22.4867 7.03125C24.4555 7.03125 26.5156 7.38281 26.5156 7.38281V11.8125H24.2446C22.0086 11.8125 21.3125 13.2012 21.3125 14.625V18H26.3046L25.5067 23.2031H21.3125V35.7821C29.9188 34.432 36.5 26.986 36.5 18Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5067 23.2031L26.3047 18H21.3125V14.625C21.3125 13.2012 22.0086 11.8125 24.2446 11.8125H26.5157V7.38281C26.5157 7.38281 24.4555 7.03125 22.4867 7.03125C18.3735 7.03125 15.6875 9.5238 15.6875 14.0344V18H11.1172V23.2031H15.6875V35.7821C16.6051 35.9262 17.5438 36 18.5 36C19.4563 36 20.395 35.9262 21.3125 35.7821V23.2031H25.5067Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fa2fe3ed9023d5bf560619483997cb20.svg";
export { ForwardRef as ReactComponent };